<div mat-dialog-draggable-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
	<!--cdkDragHandle-->
	<a class="float-right btnClose" (click)="cerrarPopup()"><i class="fal fa-times" style="cursor: pointer;"></i></a>
	<a class="float-right btnClose" (click)="maximizarPopup()"><i class="fal fa-window-maximize"></i></a>
	<a class="float-right btnClose" (click)="minimizarPopup()"><i class="fal fa-window-minimize"></i></a>
	<div class="matTitulo">
		<i class="fa fa-car" id="ico"></i>
		<h1 style="display:inline-block;">Usuarios</h1>
	</div>
	<mat-divider></mat-divider>
</div>
<div class="kt-portlet">
	<div class="kt-portlet__head">
		<div class="mt-3 col-md-10 row">
			<div class="mt-2 col-md-2">Clientes:</div>
			<div class="col-md-10">
				<dx-select-box [dataSource]="clientes" placeholder="Selecciona cliente" displayExpr="nombre"
					valueExpr="id" [(value)]="idCliente" (onValueChanged)="obtenerUsuariosCliente()"></dx-select-box>
			</div>
		</div>
		<div class="mt-3">
			<kt-boton-exportar-tabla [tipoBoton]="'monitoreo'" [nombreArchivo]="'Usuarios'" [datos]="datosReporte"
				[buttonDisabled]="isDisabled">
			</kt-boton-exportar-tabla>
		</div>
	</div>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="usuarios"
							[showBorders]="true" style="margin:0 auto;" [rowAlternationEnabled]="true">
							<dxo-paging [pageSize]="5"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-filter-row [visible]="showFilterRow" [applyFilter]="currentFilter"></dxo-filter-row>
							<dxi-column caption="Acciones" cellTemplate="Abrir" alignment="center" [width]="100">
							</dxi-column>
							<dxi-column dataField="nombreCompleto" alignment="center" caption="Nombre">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let d of 'Abrir'" style="text-align: center;">
								<ng-container></ng-container>
								<mat-checkbox (change)="changeValue($event.checked, d.data)"></mat-checkbox>
							</div>
						</dx-data-grid>
					</div>
				</div>
				<div class="row">
					<div class="offset-md-10">
						<button id="agregarBoton" mat-raised-button class="mt-3 btn btn-success"
							(click)="obtenerProductosUsuario()"><i class="far fa-search"></i>&nbsp;Buscar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
